import React from 'react';

import {isAfter, isBefore, isValid} from 'date-fns';

import {Label} from '../Label';

import {CustomDatePicker, RangeInputContainer, RangeSeparator} from './styled';

type DatePair = [Date | null, Date | null];

interface Props {
    value?: DatePair;
    onChange?: (value: DatePair | undefined) => void;
    hasError?: boolean;
    label?: string;
    formFieldName?: string;
}

export const DateRange = ({value, onChange, label, hasError}: Props) => {
    const [valueFrom, valueTo] = value || [null, null];
    const onValueChange = (date: Date | null, index: 0 | 1) => {
        const start2020Year = new Date('2020-01-01');
        const isOlder2020Year = date && isValid(date) && isBefore(date, start2020Year);
        if (isOlder2020Year) date = start2020Year;

        const isAfterCurrentDate = date && isValid(date) && isAfter(date, new Date());
        if (isAfterCurrentDate) date = new Date();

        if (!onChange) return;

        const result: DatePair = index === 0 ? [date, valueTo] : [valueFrom, date];
        onChange(result.every((elem) => elem == null) ? undefined : result);
    };

    return (
        <Label text={label} hasError={hasError}>
            <RangeInputContainer>
                <CustomDatePicker
                    selected={valueFrom}
                    onChange={(date: any) => onValueChange(date, 0)}
                    selectsStart
                    startDate={valueFrom}
                    endDate={valueTo}
                    maxDate={valueTo}
                    hasError={hasError}
                />
                <RangeSeparator />
                <CustomDatePicker
                    selected={valueTo}
                    onChange={(date: any) => onValueChange(date, 1)}
                    selectsEnd
                    startDate={valueFrom}
                    endDate={valueTo}
                    minDate={valueFrom}
                    hasError={hasError}
                />
            </RangeInputContainer>
        </Label>
    );
};
